module.exports = __webpack_public_path__ + "static/portfolio-11-a37c298f39ace29d9277382a035786bb.jpg";